import Api from "~/service/Api";

class ProductRepository {
  fetch(query = {}) {
    return Api.get("/products", query);
  }

  fetchOne(productId) {
    return Api.get(`/products/${productId}`);
  }
}

export default ProductRepository;
